<template>
  <layout-content>
    <template slot="header">{{ $t('integration.v2.breadcrumb.title') }}</template>
    <tabs type="card" :animated="false" :value="$route.name" @on-click="set_tab">
      <tab-pane
        v-for="tab in tabs"
        :key="tab"
        :name="`integration.api_v2.${tab}`"
        :label="get_name_tab(tab)"
      />
    </tabs>
    <router-view />
  </layout-content>
</template>

<script>
  const doc = [
    {
      name: 'general',
      title: 'Что такое ZORRA API?',
      text:
        'ZORRA API — это простой метод использования некоторых функций нашего сервиса с вашими собственными приложениями. Вы можете использовать API для отправки сообщений, получения состояний рассылки и т. д.'
    },
    { name: 'token', title: 'Обновление токена' },
    { name: 'user', title: 'Информация о пользователе' },
    { name: 'sms', title: 'SMS рассылки' },
    { name: 'verification', title: 'Верификация номеров' },
    { name: 'databases', title: 'Базы данных' },
    { name: 'hlr', title: 'HLR запросы' }
  ];

  export default {
    data: () => ({
      tabs: doc.map((i) => i.name)
    }),
    methods: {
      set_tab: function (name) {
        this.$router.push({
          name: name
        });
      },
      get_name_tab(name) {
        return this.$t(`integration.v2.breadcrumb.${name}`);
      }
    }
  };
</script>
